import { Component, ElementRef, Inject, Input, OnInit, Renderer2, RendererStyleFlags2, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PrinterSettings } from '../../../../@core/interfaces/masters/printersettings';
import { DischargeTmpl } from '../../../../@core/interfaces/masters/discharge-tmpl';
import { commonsettings } from '../../../../data/ezoTempSettings';
import { DateService } from '../service/date.service';
import { DomSanitizer } from '@angular/platform-browser';
import { PrintServiceService } from './../../../../@theme/components/common/service/print-service.service';
import { DOCUMENT } from '@angular/common';
import * as title from './../../../../data/title.json';

@Component({
  selector: 'ngx-stickers-template',
  templateUrl: './stickers-template.component.html',
  styleUrls: ['./stickers-template.component.scss','../../../../../assets/css/stickertmpl.css']
})
export class StickersTemplateComponent implements OnInit {

  constructor(
    public dateobj:DateService,
    public PrintServiceService:PrintServiceService,
    @Inject(DOCUMENT) public document: any, private fb: FormBuilder, 
    public sanitizer: DomSanitizer,
    private renderer: Renderer2
  ) { 
    this.psDetails = PrintServiceService.onGetPrinterSettings();
    this.fontdialogForm = this.fb.group({
      elementVal: this.fb.control(null),
      fontfamily: this.fb.control(this.commonSettings?.fontfamily),
      fontColor: this.fb.control('#333333'),
      fontSize: this.fb.control(12),
      isBold: this.fb.control(false),
      isItalic: this.fb.control(false),
      isUnderline: this.fb.control(false),
      linespace: this.fb.control(1),
      textAlign: this.fb.control("left"),
      outdent: this.fb.control(0),
      indent: this.fb.control(0),
      textheight: this.fb.control(1)
    });
    this.templateForm = this.fb.group({
      //Template prop
     
      tmplDisplaySettings:this.fb.control(null),
      ps:this.fb.control('A4',[Validators.required,],),
      lm:this.fb.control(10,[Validators.required],),
      rm:this.fb.control(10,[Validators.required],),
      tm:this.fb.control(10,[Validators.required],),
      bm:this.fb.control(10,[Validators.required],),
      height: this.fb.control(null),
      width: this.fb.control(null),
    
      
      //Header 
      pageTitle: this.fb.control('Discharge Summary'),
      // Body Table
      bodyItemLines: new FormArray([]),
     });  
   this.fontdialogForm.valueChanges.subscribe(data => this.onFontDialogValueChanged(data));

  }
  fontStyleLists=commonsettings.font_style_lists;
  commonSettings=commonsettings.template;
  tempdecSettings=commonsettings.body
  templateForm:FormGroup;
  fontdialogForm:FormGroup;
  bodyItemLines: FormArray;
  commonStylechange:string="";
  objectKeys = Object.keys;
  itemBodyList:Array<any>=[];
  psDetails:PrinterSettings;
  @Input() templateData:DischargeTmpl;
  @Input() stickerData:{[key:string]:string};
  itemvalue:Array<any>=[];
  titleList:Array<{[key:string]:string}>  = (title as any).default;
  @Input() admissionNum:string
  @ViewChild('printButton', { static: false }) printButton: ElementRef;
  @Input() regNum:number;
  @Input() copies:number[];
  @Input() stickerType:string;
  @Input() barcodeBase64:string
  imageSrc:string
 
  //Any used for complex Object
  templatePreview:any;
  ngOnInit(): void {
  }

  ngOnChanges(){
    if(this.stickerType!='IP') {
      if(this.templateData && this.copies && this.stickerData) {
        const binaryData = this.stickerData.image
        binaryData ? this.imageSrc = 'data:image/jpeg;base64,' + binaryData :this.imageSrc = null;
        if(this.copies.length) this.editdata(this.templateData)
     }
    }
    else if(this.stickerType==='IP'){
      if(this.templateData && this.copies && this.stickerData) {
        if(this.copies.length) this.editdata(this.templateData)
     }
    }
    console.info("stickerData",this.stickerData)
         
  }



  ngOnDestroy(): void {
    this.itemvalue=this.itemvalue?.map((x,index)=>{
      x.displayeditor=false;
      x.displaytext=false;
      return {...x}
    })
  }

 
  async editdata(data){  
    this.templateData=data
    this.templateForm.controls['tmplDisplaySettings'].setValue(JSON.parse(data?.tmplDisplaySettings));
    var template={...JSON.parse(data?.tmplDisplaySettings),
      temp_title:JSON.parse(data?.tempTitle),
      page_title:JSON.parse(data?.pageTitle),
      footer:JSON.parse(data?.footer)}  

    this.templateForm.controls['tm'].setValue(template?.tm);
    this.templateForm.controls['bm'].setValue(template?.bm);
    this.templateForm.controls['lm'].setValue(template?.lm);
    this.templateForm.controls['rm'].setValue(template?.rm);
    this.templateForm.controls['width'].setValue(template?.width);
    this.templateForm.controls['height'].setValue(template?.height);
    (this.templateForm.get('bodyItemLines') as FormArray).clear();
    this.bodyItemLines = this.templateForm.get('bodyItemLines') as FormArray;
    var bodyitmes=data?.dischargeTmplDet;
    this.itemvalue=[];
    this.copies.forEach(()=>{
      bodyitmes?.filter(async (x)=>{ 
        let rowItem=''
        var headerjson={
          "itemfontfamily":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontfamily,
          "itemfontcolor":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontColor,
          "itemfontsize":JSON.parse(x.rowSettings)?.header?.fontstyle?.fontSize, 
          "itemposition":JSON.parse(x.rowSettings)?.header?.fontstyle?.textAlign,
        }
        var valuejson={
          "itemfontfamily":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontfamily,
          "itemfontcolor":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontColor,
          "itemfontsize":JSON.parse(x.rowSettings)?.value?.fontstyle?.fontSize, 
          "itemposition":JSON.parse(x.rowSettings)?.value?.fontstyle?.textAlign,
        }  
            
          rowItem=this.replaceVariableTostring(x.rowDefaultValue)  
          this.itemvalue.push({value:rowItem,displayeditor:false,displaytext:true});
          this.bodyItemLines.push(this.fb.group({
            header: { itemvalue: x.rowHeaderName, ...JSON.parse(x.rowSettings).header, ...headerjson },
            value: { itemvalue: rowItem, ...JSON.parse(x.rowSettings).value, ...valuejson }
          }));
      
      });
    })

    this.itemBodyList=[...this.bodyItemLines.value.map((x,index)=>{
      return {
        index:index,...x
      }
    })];
  
    this.onPreview();
  }
  
  

  replaceVariableTostring(string){
    if(!!string){
     string=string.replace((new RegExp("{patientgender}", "g")),this.stickerData?.gender)
     .replace((new RegExp("{patientage}", "g")),this.stickerData?.age)
     .replace((new RegExp("{patienttitle}", "g")),this.stickerData?.patientTitle ? this.getPatientTitle(this.stickerData?.patientTitle):'')
     .replace((new RegExp("{patientname}", "g")),this.getPatientName(this.stickerData?.name,this.stickerData?.middleName,this.stickerData?.lastName))
     .replace((new RegExp("{patientdoa}", "g")),this.stickerData?.refDate ? this.dateobj.dateUtctoLocal(this.stickerData?.refDate,'DD-MM-YYYY hh:mm A'):'')
     .replace((new RegExp("{docname}", "g")),this.stickerData?.doctor ? this.stickerData?.doctor:'')
     .replace((new RegExp("{admdocdept}", "g")),this.stickerData?.department ? this.stickerData?.department: '')
     .replace((new RegExp("{admward}", "g")),this.stickerData?.ward ? this.stickerData?.ward : '')
     .replace((new RegExp("{admbedno}", "g")),this.stickerData?.bedNo ? this.stickerData?.bedNo :"")
     .replace((new RegExp("{patientipno}", "g")),this.admissionNum ? this.admissionNum :'')
     .replace((new RegExp("{patientid}", "g")),this.regNum? (this.stickerData?.isUnregisterPatientConverted == 'false'? this.regNum + ' || Not Yet Registered': this.regNum): '-')
     .replace((new RegExp("{barcode}", "g")),this.barcodeBase64 ? this.barcodeBase64 : '/assets/images/white.png')
     .replace((new RegExp("{patientaddress}", "g")),this.stickerData?.address ? this.stickerData?.address : '')
     .replace((new RegExp("{patientmno}", "g")),this.stickerData?.mobile ? this.stickerData?.mobile : '')
     .replace((new RegExp("{patientdro}", "g")),this.stickerData?.refDate ? this.dateobj.dateUtctoLocal(this.stickerData?.refDate,'DD-MM-YYYY hh:mm A'):'')
     .replace((new RegExp("{imagesrc}", "g")),this.imageSrc ? this.imageSrc :'/assets/images/white.png')
     
    
    }
    return string;
   }

  async onPreview(){
    this.templatePreview=this.templateForm.value; 
    await this.sleep(1000) 

    this.templatePreview?.bodyItemLines?.forEach(async (x,index) => {
       var bodyval={...x.value.fontstyle,elementVal:null};
       var bodyelem=document.getElementById("itembodyvalue"+index) as HTMLElement;
       if(!!bodyelem){
          bodyval.elementVal=bodyelem;
          this.onFontDialogValueChanged(bodyval); 
       }
    }); 
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
onFontDialogValueChanged(data){  
     if(!!data && !!data.elementVal)
        this.setfontstyle(data);
     if(!!this.commonStylechange){
      this.templatePreview?.bodyItemLines?.forEach(async (x,index) => {
        if(this.commonStylechange=="header"){
          var headerval=this.fontdialogForm.value;
          headerval.elementVal=document.getElementById("itembodyheader"+index) as HTMLElement;
          this.setfontstyle(headerval);
        }
        if(this.commonStylechange=="value"){
          var bodyval=this.fontdialogForm.value;
          bodyval.elementVal=document.getElementById("itembodyvalue"+index) as HTMLElement;
          this.setfontstyle(bodyval);  
        }
     }); 
    }
  }
  setfontstyle(data){
    const flags = RendererStyleFlags2.DashCase | RendererStyleFlags2.Important;
    this.renderer.setStyle(data?.elementVal, 'color', data?.fontColor,flags);
    this.renderer.setStyle(data?.elementVal, 'font-size', data?.fontSize+'pt',flags);
    this.renderer.setStyle(data?.elementVal, 'font-family', data?.fontfamily,1);
    this.renderer.setStyle(data?.elementVal, 'font-weight', data?.isBold?'bold':'normal');
    this.renderer.setStyle(data?.elementVal, 'font-style', data?.isItalic?'italic':'normal');
    this.renderer.setStyle(data?.elementVal, 'text-decoration', data?.isUnderline?'underline':'none');
    this.renderer.setStyle(data?.elementVal, 'text-align', data?.textAlign,1);
    this.renderer.setStyle(data?.elementVal, 'line-height', data?.textheight,1);
    this.renderer.setStyle(data?.elementVal, 'padding-left', data?.indent+"px"); 
  }



  async printBarcode(){
    var content = document.getElementById('stickerTmpl').innerHTML;
    var width= +this.templatePreview?.width
    var height= +this.templatePreview?.height
    await this.PrintServiceService.stickerPrint(content, this.psDetails,width, height,this.templatePreview?.tm,this.templatePreview?.lm);
  }

  onPrint(){
    if (this.printButton && this.printButton.nativeElement) {
      this.printButton.nativeElement.click();
    }
  }

  getPatientTitle(data){
    return this.titleList.find(e=>e.value==data)?.title;
  }
  getPatientName(firstname:string,middlename:string,lastname:string):string{
    let fullname:string='';
    if(!!firstname){
      fullname=firstname
    }
    if(!!middlename){
      fullname+=" "+middlename
    }
    if(!!lastname){
      fullname+=" "+lastname
    }
    return fullname
}



  


}
